import ReactDOM from "react-dom/client";

import App from "./App.tsx";
import { PostHogProvider } from "./components/PostHogProvider";

import "@/styles/globals.css";
import "@/i18n/config.ts";
import { scan } from "react-scan";

scan({ enabled: false });
ReactDOM.createRoot(document.getElementById("root")!).render(
  <PostHogProvider>
    <App />
  </PostHogProvider>
);